import React from "react";
import { useRecoilState } from "recoil";
import ScreenCard from "../ScreenCard";
import { newMissionState } from "../../atoms/core";
import { CreateMissionScreensContext } from "../../contexts/CreateMissionManager";
import { WorkerInfo } from "../../__generated__/graphql";
import MissionWorker from "../../components/editors/MissionWorker";
import { useI18n } from "../../hooks/i18n-hooks";
import { Bubble } from "../../components/Bubble";
import { useBubbleStepOrigin } from "../../hooks/use-bubble-step-origin";

const CreateMissionWorker = () => {
    const i18n = useI18n();
    const [mission, setMission] = useRecoilState(newMissionState);
    const { validateScreen } = React.useContext(CreateMissionScreensContext);
    const setWorkerinfo = React.useCallback(
        (value: WorkerInfo) => {
            setMission({
                ...mission,
                workerInfo: value,
            });
        },
        [mission, setMission],
    );
    const validate = React.useCallback(() => {
        void validateScreen("CreateMissionWorker");
    }, [validateScreen]);

    const origin = useBubbleStepOrigin("CreateMissionWorker");

    // this is a small optimization to avoid re-rendering the whole screen when mission didn't change
    // this happens when the user goes back and forth between screens
    const content = React.useMemo(() => {
        return (
            <ScreenCard
                buttons={[
                    {
                        title: i18n.translate("next"),
                        onPress: validate,
                        isValid: !!mission.workerInfo,
                    },
                ]}
            >
                <Bubble
                    title={i18n.t("screens.user.create_mission_worker.title")}
                    bubbleStyle={{ paddingBottom: 0 }}
                    origin={origin}
                >
                    <MissionWorker mission={mission} setWorkerInfo={setWorkerinfo}></MissionWorker>
                </Bubble>
            </ScreenCard>
        );
    }, [i18n, validate, mission, origin, setWorkerinfo]);

    return content;
};

export default CreateMissionWorker;
